export enum BusEvents {
  error = 'error',
  warning = 'warning',
  success = 'success',
  info = 'info',
}
